import { apiQuery, atsApiQuery } from '../';

export const contactsOldApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllContacts: builder.query({
        providesTags: ['GetAllContacts'],
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          return {
            method: 'post',
            data: payload,
            url: `/search/circles/contacts`,
          };
        },
      }),

      getContactById: builder.query({
        providesTags: ['GetContactById'],
        transformResponse: (response) => response?.data?.contact,
        query: ({ contactId }) => {
          return {
            method: 'get',
            url: `/contacts/${contactId}`,
          };
        },
      }),

      markContactAsTopTalent: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload }) => {
          return {
            url: `/user_contacts/${contactId}`,
            method: 'post',
            data: { ...payload },
          };
        },
      }),

      contactTalent: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId }) => {
          return {
            url: `/user_contacts/${contactId}`,
            method: 'put',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllContacts' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

//new endpoint ats
export const contactsNewApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      createContact: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: '/contacts',
            method: 'post',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllContacts' }];
          }
          return [];
        },
      }),

      importContacts: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: `ats_applications/bulk_create_from_contacts`,
            method: 'post',
            data: { ...payload },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetAllContactsQuery,
  useLazyGetContactByIdQuery,
  useContactTalentMutation,
} = contactsOldApi;

export const { useCreateContactMutation, useImportContactsMutation } =
  contactsNewApi;
